import React, { useState } from 'react';
import Header from './Header';
import SidebarComponent from './Sidebar';


const Layout = ({ children }) => {
    const [sidebarVisible, setSidebarVisible] = useState(false);

    const handleToggleSidebar = () => {
        setSidebarVisible(!sidebarVisible);
    };

    const handleCloseSidebar = () => {
        setSidebarVisible(false);
    };

    return (
        <div className="layout-container">
            <Header
                title="WGSol" 
                onToggleSidebar={handleToggleSidebar}
                showThemeSwitcher={true}
            />
            
            <div className="layout-content">
                <SidebarComponent
                    visible={sidebarVisible}
                    onHide={handleCloseSidebar}
                />
                <div className="layout-main">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Layout;
